import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Indicador numérico isolado: rótulo, valor em destaque e dica opcional.
 * `loading` mostra skeleton no lugar do valor.
 */
export default function KpiTile({ label, value, hint, loading = false }) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack spacing={0.5}>
          <Typography variant="overline" color="text.secondary">{label}</Typography>
          <Typography variant="h4">
            {loading ? <Skeleton width="60%" /> : value}
          </Typography>
          {hint && (
            <Typography variant="body2" color="text.secondary">
              {loading ? <Skeleton width="80%" /> : hint}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
